import { Component, Input, OnInit, TemplateRef } from "@angular/core";
import { ModalsService } from "../modals.service";

@Component({
    selector: "app-modals",
    templateUrl: "./modals.component.html",
    styleUrls: ["./modals.component.scss"],
})
export class ModalsComponent implements OnInit {
    constructor(public modalsService: ModalsService) {}

    ngOnInit(): void {}
}
